<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Coaching Hub" class="d-icon d-icon--coaching-hub" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M8.99 4.757V3.182a.4.4 0 0 0-.4-.4h-.403a.949.949 0 0 1-.948.9H4.54a.948.948 0 0 1-.947-.9h-.402a.4.4 0 0 0-.4.4v6.3a.401.401 0 0 0 .4.401h1.574a.5.5 0 0 1 0 1H3.19a1.4 1.4 0 0 1-1.4-1.4V3.182a1.4 1.4 0 0 1 1.4-1.4h.402a.95.95 0 0 1 .947-.9h2.7a.95.95 0 0 1 .947.9h.403a1.4 1.4 0 0 1 1.4 1.4v1.575a.5.5 0 0 1-1 0Zm-4.4-2.075h2.6v-.8h-2.6v.8Zm1.29 1.85c.058 0 .108.04.126.095a2.789 2.789 0 0 0 1.81 1.823c.058.018.098.07.098.13s-.04.113-.097.131a2.788 2.788 0 0 0-1.793 1.766.153.153 0 0 1-.144.106.153.153 0 0 1-.144-.106 2.788 2.788 0 0 0-1.77-1.758.147.147 0 0 1-.102-.139c0-.063.043-.118.103-.138a2.788 2.788 0 0 0 1.788-1.815.132.132 0 0 1 .125-.094Zm2.474 3.356a.09.09 0 0 1 .084.064A1.87 1.87 0 0 0 9.644 9.18a.094.094 0 0 1 .066.088.095.095 0 0 1-.066.09 1.869 1.869 0 0 0-1.194 1.188.103.103 0 0 1-.097.072.103.103 0 0 1-.096-.072c-.186-.559-.624-1-1.179-1.184a.1.1 0 0 1-.068-.094.1.1 0 0 1 .068-.093A1.869 1.869 0 0 0 8.27 7.952a.089.089 0 0 1 .084-.064Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconCoachingHub',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
